module.exports = __webpack_public_path__ + "img/logo.e89e7347.png";